import { EcommerceAPI } from "../Client";
import { appendProcessedFiles } from "../../../utils/imageUploadProcessor";

const getDesignPayload = (payload = {}) => {
  if (payload?.dto) return payload.dto;

  const { productId, uploadId, ...designPayload } = payload;
  return designPayload;
};

const getSizeDesignPayload = (payload = {}) => {
  if (payload?.dto) return payload.dto;

  const { uploadId, ...designPayload } = payload;
  return designPayload;
};

export const getProductDesignApi = async (payload = {}) => {
  try {
    const id = payload?.id ?? payload;
    const response = await EcommerceAPI.get(`/product/design?id=${id || ""}`);
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const postProductDesignApi = async (payload = {}) => {
  try {
    const response = await EcommerceAPI.post(
      `/product/design?productId=${payload?.productId || ""}`,
      getDesignPayload(payload)
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const postProductSizeDesignApi = async (payload = {}) => {
  try {
    const response = await EcommerceAPI.post(
      `/product/size/design?sizeId=${payload?.sizeId || ""}`,
      getSizeDesignPayload(payload)
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const updateProductDesignApi = async (payload = {}) => {
  try {
    const response = await EcommerceAPI.put(
      `/product/design?productId=${payload?.productId || ""}`,
      getDesignPayload(payload)
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const deleteProductDesignApi = async (payload = {}) => {
  try {
    const id = payload?.id ?? payload;
    const response = await EcommerceAPI.delete(`/product/design?id=${id || ""}`);
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const getAllProductDesignApi = async (payload = {}) => {
  try {
    const productId = payload?.productId ?? payload;
    const response = await EcommerceAPI.get(
      `/product/design/all?productId=${productId || ""}`
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const postProductDesignFilesApi = async (payload = {}) => {
  try {
    const formData = new FormData();

    await appendProcessedFiles(formData, "files", payload?.files || []);

    const response = await EcommerceAPI.post(`/product/design/files`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const deleteProductDesignFileApi = async (payload = {}) => {
  try {
    const uploadId = payload?.uploadId ?? payload;
    const response = await EcommerceAPI.delete(
      `/product/design/file?uploadId=${uploadId || ""}`
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};
